import WeaAssociativeSearch from "../base/wea-associative-search";
import WeaAssociativeSearchMult from "../base/wea-associative-search-mult";
import middleware from "../../middleware";

class main extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { props } = this;
    if (props.mult) {
      delete props.mult;
      return <WeaAssociativeSearchMult {...props} />;
    }
    return <WeaAssociativeSearch {...props} />;
  }
}

const Com = middleware(main, "WeaAssociativeSearch");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-associative-search/index.js